/**
 * Composable для работы с уведомлениями
 */
import { storeToRefs } from 'pinia'
import { useNotificationsStore } from '../stores/notifications.store'

export const useNotifications = () => {
  const store = useNotificationsStore()

  const { notifications, unreadCount, total, isLoading, preferences, isPanelOpen } =
    storeToRefs(store)

  return {
    // State
    notifications,
    unreadCount,
    total,
    isLoading,
    preferences,
    isPanelOpen,

    // Actions
    fetchUnreadCount: store.fetchUnreadCount,
    fetchNotifications: store.fetchNotifications,
    loadMore: store.loadMore,
    markRead: store.markRead,
    markAllRead: store.markAllRead,
    fetchPreferences: store.fetchPreferences,
    updatePreferences: store.updatePreferences,
    togglePanel: store.togglePanel,
    closePanel: store.closePanel,
    startPolling: store.startPolling,
    stopPolling: store.stopPolling,
  }
}
